"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
function PanelItem(props) {
    const { onClick, image, text, id, isSelected = true } = props;
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const theme = (0, styled_components_1.useTheme)();
    const onLoad = () => {
        setIsLoaded(true);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            onClick();
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { id: id, onClick: onClick, isSelected: isSelected, tabIndex: 0, onKeyDown: handleKeyDown, "data-e2e": 'PanelItem_Container', children: [(0, jsx_runtime_1.jsxs)(ImageContainer, { "data-e2e": 'PanelItem_ImageContainer', children: [!isLoaded && ((0, jsx_runtime_1.jsx)(StyledProgressBar, { "data-e2e": 'PanelItem_StyledProgressBar', children: (0, jsx_runtime_1.jsx)(ui_1.ProgressIndicator, { color: theme.grasshopper.loadingColor, "data-e2e": 'PanelItem_ProgressIndicator' }) })), (0, jsx_runtime_1.jsx)(StyledImage, { src: image, onLoad: onLoad, onError: onLoad, "data-e2e": 'PanelItem_StyledImage' })] }), (0, jsx_runtime_1.jsx)(TextContainer, { "data-e2e": 'PanelItem_TextContainer', children: (0, jsx_runtime_1.jsx)(StyledTruncatedText, { "data-e2e": 'PanelItem_StyledTruncatedText', children: text }) })] }));
}
exports.default = PanelItem;
const StyledProgressBar = styled_components_1.default.div `
  position: absolute;
`;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 150px;
  height: 180px;
  cursor: pointer;
  background: ${({ theme }) => theme.grasshopper.spotsPanel.itemBackground};
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  outline: none;

  &:hover {
    background: ${({ theme }) => theme.grasshopper.spotsPanel.selectedBackground};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.grasshopper.focusBorder};
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    flex-direction: row;
    width: 100%;
    height: 61px;
    box-shadow: none;
  `)};

  ${({ isSelected, theme }) => isSelected &&
    (0, styled_components_1.css) `
      outline: 1px solid ${theme.grasshopper.spotsPanel.selectedBorder};
      &:focus-visible {
        outline: 2px solid ${theme.grasshopper.focusBorder};
      }

      ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
        background: ${theme.grasshopper.spotsPanel.itemBackground};
        &:focus-visible {
          outline: 1px solid ${theme.grasshopper.spotsPanel.selectedBorder};
        }
      `)};
    `}
`;
const ImageContainer = styled_components_1.default.div `
  width: 100%;
  height: 112px;
  margin: 0;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.grasshopper.spotsPanel.imageBackground};

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    width: 81px;
    height: 100%;
    padding: 12px;
    border-radius: 8px;
  `)};
`;
const StyledImage = styled_components_1.default.img `
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
const TextContainer = styled_components_1.default.div `
  font-size: 16px;
  line-height: 18.32px;
  width: 100%;
  height: 62px;
  color: ${({ theme }) => theme.grasshopper.text.white};

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    display: flex;
    align-items: center;
  `)};
`;
const StyledTruncatedText = styled_components_1.default.p `
  margin: 8px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -moz-box-orient: vertical;
  -ms-box-orient: vertical;
  text-overflow: ellipsis;
  white-space: normal;

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    -webkit-line-clamp: 3;
  `)};
`;
